// Login.js
import React, { useState } from 'react';
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
} from '@aws-sdk/client-cognito-identity-provider';

const REGION = 'us-west-2';
const USER_POOL_CLIENT_ID = '3bh5kvk0a93asjbakn19tgjcms';

const cognitoIdpClient = new CognitoIdentityProviderClient({ region: REGION });

export default function Login({ onLoginSuccess, onError }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const signIn = async () => {
    setLoading(true);
    try {
      const command = new InitiateAuthCommand({
        AuthFlow: 'USER_PASSWORD_AUTH',
        ClientId: USER_POOL_CLIENT_ID,
        AuthParameters: {
          USERNAME: username,
          PASSWORD: password,
        },
      });

      const response = await cognitoIdpClient.send(command);

      if (response.AuthenticationResult) {
        const { AccessToken, IdToken, RefreshToken } = response.AuthenticationResult;
        // You can pass more than just IdToken if needed
        onLoginSuccess({ idToken: IdToken, accessToken: AccessToken, refreshToken: RefreshToken });
      } else {
        throw new Error('Authentication failed. No tokens returned.');
      }

    } catch (error) {
      console.error('Login error:', error);
      const message =
        error?.name === 'InvalidParameterException'
          ? 'USER_PASSWORD_AUTH flow is not enabled. Enable it in your Cognito App Client settings.'
          : error?.message || 'Login failed. Please check your credentials.';
      onError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form">
      <h2>Sign In</h2>
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        disabled={loading}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        disabled={loading}
      />
      <button onClick={signIn} disabled={loading || !username || !password}>
        {loading ? 'Signing in...' : 'Sign In'}
      </button>
    </div>
  );
}
